/* =========================================================
   Plantive Reviews - JS (Optimized OOP)
========================================================= */
document.addEventListener('DOMContentLoaded', () => {

  const reviewSections = document.querySelectorAll('.plv-rev-container');

  reviewSections.forEach(section => {
    // 1. Intersection Observer for Animations
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    observer.observe(section);

    // 2. Init Swiper
    const swiperContainer = section.querySelector('.plv-rev-swiper');
    if (!swiperContainer) return;

    const isLoop = section.getAttribute('data-loop') === 'true';

    function initReviewsSwiper() {
      if (typeof Swiper === 'undefined') {
        setTimeout(initReviewsSwiper, 100);
        return;
      }

      new Swiper(swiperContainer, {
        slidesPerView: 1.15,
        centeredSlides: true,
        loop: isLoop,
        speed: 800,
        grabCursor: true,
        spaceBetween: 16,
        
        navigation: {
          nextEl: section.querySelector('.custom-next'),
          prevEl: section.querySelector('.custom-prev'),
        },
        
        pagination: {
          el: section.querySelector('.custom-swiper-pagination'),
          clickable: true,
        },
        
        on: {
          slideNextTransitionStart: function () {
            swiperContainer.setAttribute('data-dir', 'next');
          },
          slidePrevTransitionStart: function () {
            swiperContainer.setAttribute('data-dir', 'prev');
          }
        },
        
        breakpoints: {
          991: {
            slidesPerView: 1.3,
            spaceBetween: 32,
            centeredSlides: true
          }
        }
      });
    }

    initReviewsSwiper();
  });
});